export class OptionText {
  constructor(
    public hash?: string,
    public key?: string,
    public text?: string
  ) {}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/option-text.ts